// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3XkA5","header":"MessagesList_header__1cfI0","chat":"MessagesList_chat__1G992"};